<template>
  <div class="vacancy-main__items">
    <div v-if="vacancy[2].physical_activity || vacancy[2].physical_activity_description"
         :class="{'_open': isPhysicalActivity}"
         class="vacancy-main__item">
      <div @click.prevent="desktopOrTablet ? null : (isPhysicalActivity = !isPhysicalActivity)"
           class="vacancy-main__item-head">
        <BaseSvg name="ico-weight"
                 width="2rem"
                 height="1.9rem"
                 class="vacancy-main__item-ico  d-none  d-sm-inline"/>
        <BaseSvg name="ico-weight"
                 width="2.1rem"
                 height="2.8rem"
                 class="vacancy-main__item-ico  d-sm-none"/>
        <div v-if="vacancy[2].physical_activity"
             class="vacancy-main__item-title">
          {{ $get(vacancy[2], 'physical_activity.name') }} {{ $tVacancy('load') }}
        </div>
        <BaseSvg v-if="vacancy[2].physical_activity_description"
                 name="ico-arrow-down"
                 class="vacancy-main__item-arrow  d-none  d-sm-inline"/>
      </div>

      <CollapseTransition>
       <div v-show="isPhysicalActivity"
            class="vacancy-main__item-text-wrap">
         <div v-if="vacancy[2].physical_activity_description"
              v-html="vacancy[2].physical_activity_description"
              class="vacancy-main__item-text  text"></div>
       </div>
      </CollapseTransition>
    </div>

    <div v-if="typeof vacancy[2].acceptable_disability === 'boolean' || vacancy[2].acceptable_disability_description"
         :class="{'_open': isOpenDisability}"
         class="vacancy-main__item">
      <div @click.prevent="desktopOrTablet ? null : (isOpenDisability = !isOpenDisability)"
           class="vacancy-main__item-head">
        <BaseSvg name="ico-disabled-sign"
                 width="2rem"
                 height="2rem"
                 class="vacancy-main__item-ico  d-none  d-sm-inline"/>
        <BaseSvg name="ico-disabled-sign"
                 width="2.3rem"
                 height="2.8rem"
                 class="vacancy-main__item-ico  d-sm-none"/>
        <div v-if="typeof vacancy[2].acceptable_disability === 'boolean'"
             class="vacancy-main__item-title">
          {{ vacancy[2].acceptable_disability ? $tVacancy('Accept disability') : $tVacancy('Not accept disability') }}
        </div>
        <BaseSvg v-if="vacancy[2].acceptable_disability_description"
                 name="ico-arrow-down"
                 class="vacancy-main__item-arrow  d-none  d-sm-inline"/>
      </div>
      <CollapseTransition>
        <div v-show="isOpenDisability"
             class="vacancy-main__item-text-wrap">
          <div v-if="vacancy[2].acceptable_disability_description"
               v-html="vacancy[2].acceptable_disability_description"
               class="vacancy-main__item-text  text"></div>
        </div>
      </CollapseTransition>
    </div>
  </div>
</template>

<script>
  import {CollapseTransition} from 'vue2-transitions'
  import windowSizeMixin from '../../mixins/windowSizeMixin';

  export default {
    name: 'VacancyMainItems',
    components: {
      CollapseTransition
    },
    mixins: [windowSizeMixin],
    props: ['vacancy', 'isMob'],
    data() {
      return {
        isPhysicalActivity: false,
        isOpenDisability: false,
      }
    },
    computed: {
      desktopOrTablet() {
        return this.windowSizeMixin.width > 768;
      },
    },
  }
</script>

<style lang="less">

</style>
